import { render } from "./ProductsList.vue?vue&type=template&id=76dafb53"
import script from "./ProductsList.vue?vue&type=script&lang=js"
export * from "./ProductsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__